module.exports = __webpack_public_path__ + "img/4b3a7079e86d247e6a6cc0008a904fae.png";